
import React, { useState } from 'react';
import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { useStore } from '../../../../providers/AppProvider';
import { getYears } from '../../../../utils/misc';
import { SETTING_SEASON_YEAR } from '../../../../utils/settings';

type SeasonSelectorProps = {}

const SeasonSelector = ({}:SeasonSelectorProps) => {
    const { settings, updateSettings } = useStore();
    
    const [year, setYear] = useState(settings[SETTING_SEASON_YEAR]);

    const onSelect = (year: string, event: any) => {
        event.stopPropagation();
        updateSettings(SETTING_SEASON_YEAR, year);
        setYear(year);
    }

    return (
        <div className="d-flex flex-column pb-1 pt-1 px-3">
            <DropdownButton 
                as={ButtonGroup}
                id="season-selector"
                variant="light"
                size="sm"
                onSelect={(key:any, e:any) => onSelect(key, e)}
                title={`Season ${year}`}>
                {getYears(2010, true).map((year: number) => (
                    <Dropdown.Item key={year} eventKey={`${year}`}>{year}</Dropdown.Item>
                )  
            )}
            </DropdownButton>
        </div>
    );
}

export default SeasonSelector;